import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostBinding,
    HostListener,
    Input,
    Output,
} from '@angular/core';

import { IconModule, SharedUiModule } from '@pf/shared-ui';
import { CpwTask } from '@cpw/domain';

@Component({
    selector: 'cpw-task-list-item',
    standalone: true,
    imports: [SharedUiModule, IconModule],
    templateUrl: './cpw-task-list-item.component.html',
    styleUrls: ['./cpw-task-list-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpwTaskListItemComponent {
    @Input({ required: true }) task!: CpwTask;

    @HostBinding('class.priority-item')
    get priority(): boolean {
        return this.task.priority;
    }

    @HostBinding('class.readonly-item')
    @Input()
    readonly = false;

    // Color-code the card accent by equipment group (Parts=green,
    // Uniforms=purple; LTL keeps the default brand blue). Priority and
    // readonly states keep their own colors, so skip the group class for those.
    @HostBinding('class.group-parts')
    get isPartsGroup(): boolean {
        return !this.priority && !this.readonly && this.task?.group === 'Parts';
    }

    @HostBinding('class.group-uniforms')
    get isUniformsGroup(): boolean {
        return (
            !this.priority && !this.readonly && this.task?.group === 'Uniforms'
        );
    }

    @HostBinding('attr.role') role = 'button';
    @HostBinding('attr.tabindex') tabindex = 0;

    @Output() taskSelected = new EventEmitter<CpwTask>();

    @HostListener('click')
    openDetailsHandler(): void {
        if (this.readonly) return;
        this.taskSelected.emit(this.task);
    }
}
